
import axios from "axios";
import { mapMutations } from 'vuex'; 
export default {
    name: "article-card",
    props: {
        article: Object,
        model_id: String,
        pa_count: Number,
        article_idx: Number,
        pa_page: String,
        close_utils: Boolean
    },
    data() {
        return {
            collect_status: this.article.collect,
            like_status: this.article.like,
            show_this_article: true,
            isVisible: true,
            like_count: this.article.like_count ? this.article.like_count : 0,
            block_click_status: false,
            pa_action_label_list: {
                '首頁': {
                    e_action: '推薦',
                    e_label: '文章',
                },
                '旅遊/國外': {
                    e_action: '旅遊文章',
                    e_label: '旅遊文章',
                },
                '旅遊/國內': {
                    e_action: '旅遊文章',
                    e_label: '旅遊文章',
                },
                '美食': {
                    e_action: '美食文章',
                    e_label: '美食文章',
                },
                '影視': {
                    e_action: '影視文章',
                    e_label: '影視文章',
                },
                '親子': {
                    e_action: '親子文章',
                    e_label: '親子文章',
                },
                '美妝': {
                    e_action: '美妝文章',
                    e_label: '美妝文章',
                },
                '3C': {
                    e_action: '3C文章',
                    e_label: '3C文章',
                },
                '身心靈': {
                    e_action: '身心靈文章',
                    e_label: '身心靈文章',
                },
                '寵物': {
                    e_action: '寵物文章',
                    e_label: '寵物文章',
                },
                '健康': {
                    e_action: '健康文章',
                    e_label: '健康文章',
                },
                '職涯': {
                    e_action: '職涯文章',
                    e_label: '職涯文章',
                },
                '住家': {
                    e_action: '住家文章',
                    e_label: '住家文章',
                },
                '私康': {
                    e_action: '私康文章',
                    e_label: '私康文章',
                },
            },
            random_default_img: Math.floor(Math.random()*3)
        };
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        member_token() {
            return this.$store.state.login.pix_member_token.member_token;
        },
        router_name() {
            return this.$route.name;
        },
        decode_title() {
            return decodeURIComponent(this.article.title);
        },
        router_name() {
            return this.$route.name;
        },
        article_date() {
            if (this.article.date) {
                return this.article.date;
            } else if (this.article.datetime) {
                const time = new Date(this.article.datetime)
                const month = time.getMonth() + 1;
                const date = time.getDate();
                return month.toString() + '/' + date.toString();
            }
        }
    },
    methods: {
        ...mapMutations('share', [
            'setShareLink',
            'setShareTitle',
            'toggleShareOpen',
        ]),
        ...mapMutations('report', [
            'toggleReport',
            'updateArticleId',
            'updateArticleLink',
            'updateArticleMemberId'
        ]),
        ...mapMutations('lightbox', [
            'setViewData',
        ]),
        setBlockToAvoidTooMoreClick() {
            this.block_click_status = true;
            setTimeout(()=>{
                this.block_click_status = false;
            }, 1000)
        },
        openToastElement(){
            this.$parent.openToast();
        },
        disableThisArticle() {
            this.show_this_article = !this.show_this_article;
        },
        paFunction(){
            // let pa_idx = (this.pa_count + (this.article_idx + 1)/10000).toFixed(4);
            // let reg_article_link = "http://"+ this.article.author.user_name +".pixnet.net/blog/post/" + this.article.id;
            // window._piq.push([
            //     'trackEvent',
            //     `rs2022::十大頻道::${this.pa_page}`,
            //     `imps::${this.pa_action_label_list[this.pa_page].e_action}::article_card::${this.model_id}`,
            //     `${this.pa_action_label_list[this.pa_page].e_label}::${reg_article_link}`,
            //     pa_idx
            // ]);
        },
        paClickFunction(){
            // let pa_idx = (this.pa_count + (this.article_idx + 1)/10000).toFixed(4);
            // let reg_article_link = "http://"+ this.article.author.user_name +".pixnet.net/blog/post/" + this.article.id;
            // window._piq.push([
            //     'trackEvent',
            //     `rs2022::十大頻道::${this.pa_page}`,
            //     `click::${this.pa_action_label_list[this.pa_page].e_action}::article_card::${this.model_id}`,
            //     `${this.pa_action_label_list[this.pa_page].e_label}::${reg_article_link}`,
            //     pa_idx
            // ]);
        },
        imgOnError(event) {
            event.target.src = 'https://www.pixnet.net/img/public/default/img_default_'+ this.random_default_img +'.png';
        },
        visibilityChanged(isVisible, entry) {
            this.isVisible = isVisible
            if (entry.intersectionRatio > 0) {
                this.paFunction()  
            }
        }
    },
    mounted() {
    }
};
